import { render, staticRenderFns } from "./ElementCommentYearTableColumn.vue?vue&type=template&id=6f9a9fbb&scoped=true"
import script from "./ElementCommentYearTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementCommentYearTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementCommentYearTableColumn.vue?vue&type=style&index=0&id=6f9a9fbb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9a9fbb",
  null
  
)

export default component.exports